export default [
  {
    label: "field.preTrainMessages",
    type: "text-area",
    rules: "required",
    cols: "12",
  },
];
